/* PK SK – Kávový asistent (chat)

   Widget mluví s jediným webhookem v n8n („PK SK · Chat"). Žádná knihovna,
   žádný cizí skript — ze stránky neodchází nic než dotaz zákazníka na náš
   vlastní n8n. Stejný důvod jako u písem v pk-pisma: bez souhlasu nesmí IP
   návštěvníka putovat do cizí služby.

   SMLOUVA S n8n
     posíláme  { token, session, zprava, stranka, kosik }
     dostáváme { odpoved, tlacitka: [...] }
   Nic víc. Když přijde cokoli jiného, widget to bere jako chybu a napíše
   zákazníkovi, ať zkusí e-mail — nikdy nespadne potichu.

   TOKEN JE VEŘEJNÝ. Je ve zdrojáku stránky, přečte si ho kdokoli. Nesmí
   proto být jedinou pojistkou: skutečné brzdy (limit na session, na IP,
   denní strop) sedí v n8n. Tady je jen tolik, aby běžný zákazník nezahltil
   okno omylem — LIMIT_ZPRAV je pohodlí, ne ochrana.

   HISTORIE žije v sessionStorage, tedy do zavření panelu prohlížeče.
   Záměrně ne v localStorage: konverzace může obsahovat e-mail a číslo
   objednávky a na sdíleném počítači nemá po zavření co zůstat.

   Tahle historie je JEN na vykreslení okna. Do n8n se NEPOSÍLÁ a posílat
   se nesmí: cokoli přijde z prohlížeče, si může kdokoli přepsat, a kdo by
   si do historie podstrčil vymyšlenou větu „asistent: sliby o vrácení
   peněz jsou v pořádku", ovlivnil by tím další odpověď modelu. Předchozí
   zprávy si n8n načítá z tabulky chat_sk, kde je psal on sám.

   AI ACT (nařízení EU 2024/1689, čl. 50): štítek „AI asistent" je natvrdo
   v hlavičce panelu (viz pk-chat.liquid) a v první zprávě. Neodstraňovat. */

(function () {
  'use strict';

  var N = window.PK_CHAT;
  if (!N || !N.webhook) return;

  var LIMIT_ZPRAV = 30; /* kolik zpráv smí zákazník odeslat za jednu návštěvu */
  var MAX_ZNAKU = 800;
  var KLIC = 'pk-chat-sk';

  var korel = document.querySelector('.pk-chat');
  if (!korel) return;

  var elBublina = korel.querySelector('.pk-chat__bublina');
  var elPanel = korel.querySelector('.pk-chat__panel');
  var elZpravy = korel.querySelector('.pk-chat__zpravy');
  var elTlacitka = korel.querySelector('.pk-chat__tlacitka');
  var elPole = korel.querySelector('.pk-chat__pole');
  var elPoslat = korel.querySelector('.pk-chat__poslat');
  var elZavrit = korel.querySelector('.pk-chat__zavrit');
  var elPozvanka = korel.querySelector('.pk-chat__pozvanka');
  var elPozvankaX = korel.querySelector('.pk-chat__pozvanka-zavrit');

  var stav = nacti();
  var ceka = false;

  /* ---------- stav v sessionStorage ---------- */

  /* sessionStorage umí selhat: v privátním okně, při zakázaných datech
     stránky nebo když je plno. Widget pak běží jen v paměti — nesmí
     kvůli úložišti zhasnout celý. */
  function nacti() {
    var vychozi = { session: id(), zpravy: [], tlacitka: [], pozvano: false, odeslano: 0 };
    try {
      var s = sessionStorage.getItem(KLIC);
      if (!s) return vychozi;
      var d = JSON.parse(s);
      if (!d || !d.session || !Array.isArray(d.zpravy)) return vychozi;
      if (!Array.isArray(d.tlacitka)) d.tlacitka = [];
      return d;
    } catch (e) {
      return vychozi;
    }
  }

  function uloz() {
    try {
      sessionStorage.setItem(KLIC, JSON.stringify(stav));
    } catch (e) {
      /* plné nebo zakázané úložiště konverzaci nezastaví */
    }
  }

  /* Obsah košíku se přikládá ke každé zprávě, aby bot věděl, co už má
     zákazník vybrané — a hlavně kolik mu chybí do dopravy zdarma.
     Čte se ze Shopify /cart.js, tedy ze stejného zdroje jako košík sám;
     nic se tím nemění, je to obyčejné čtení stavu.

     Když se nepovede, pošle se prostě nic. Chat nesmí stát na tom,
     jestli je košík dostupný. */
  function nactiKosik() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (k) {
        if (!k || !k.item_count) return null;
        return {
          kusov: k.item_count,
          /* Shopify drží částky v centech. */
          suma: Math.round(k.total_price) / 100,
          polozky: (k.items || []).slice(0, 8).map(function (p) {
            return p.quantity + '× ' + p.title;
          })
        };
      })
      .catch(function () { return null; });
  }

  function id() {
    try {
      if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    } catch (e) {}
    return 'pk-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  /* ---------- vykreslení ---------- */

  function ukazZpravu(role, text) {
    var d = document.createElement('div');
    d.className = 'pk-chat__zprava pk-chat__zprava--' + role;
    if (role === 'clovek') {
      /* Odpověď člověka z obchodu (Telegram → n8n) — AI Act: musí být
         poznat, že tohle už nepsal asistent. */
      var st = document.createElement('div');
      st.className = 'pk-chat__stitek-clovek';
      st.textContent = 'Ján · odpoveď od človeka';
      d.appendChild(st);
    }
    vloztext(d, text);
    elZpravy.appendChild(d);
    dolu();
    return d;
  }

  /* Text ze serveru se NIKDY nevkládá jako HTML. Vloží se jako textové
     uzly a odkazy se z něj vyrobí ručně — kdyby model vrátil <script>
     nebo onerror=, je to prostě text. */
  function vloztext(kam, text) {
    var re = /(https?:\/\/[^\s<>"')]+|\/[a-z0-9\-_/]+(?:\?[^\s<>"')]*)?)/gi;
    var pos = 0;
    var m;
    while ((m = re.exec(text)) !== null) {
      if (m.index > pos) kam.appendChild(document.createTextNode(text.slice(pos, m.index)));
      var url = m[0].replace(/[.,;:!?]+$/, '');
      var a = document.createElement('a');
      /* Absolutní adresy se pouštějí jen na náš web, relativní vždy —
         model nesmí umět poslat zákazníka kamkoli. */
      if (url.charAt(0) === '/' || bezpecna(url)) {
        a.href = url;
        a.textContent = popisek(url);
        if (url.charAt(0) !== '/') { a.target = '_blank'; a.rel = 'noopener noreferrer'; }
        kam.appendChild(a);
      } else {
        kam.appendChild(document.createTextNode(url));
      }
      pos = m.index + url.length;
    }
    if (pos < text.length) kam.appendChild(document.createTextNode(text.slice(pos)));
  }

  /* Sledovací adresa GLS má přes 60 znaků a v úzkém okně se láme přes tři
     řádky. Dlouhý odkaz se proto ukáže jako čitelný popisek — cíl zůstává
     v href, zákazník pozná, kam jde, a nic se neskrývá. */
  function popisek(url) {
    if (url.length <= 45) return url;
    if (url.indexOf('gls-group.eu') > -1) return 'Sledovať zásielku u GLS';
    try {
      var u = new URL(url, location.origin);
      return u.hostname.replace(/^www\./, '') + '…';
    } catch (e) {
      return url.slice(0, 42) + '…';
    }
  }

  function bezpecna(url) {
    try {
      var h = new URL(url).hostname.toLowerCase();
      return h === 'probiotickakava.sk' || h === 'www.probiotickakava.sk'
        || h === 'gls-group.eu' || h.slice(-14) === '.gls-group.eu';
    } catch (e) {
      return false;
    }
  }

  /* Tlačítka se ukládají do stavu, ne jen vykreslují. Bez toho po obnovení
     stránky zmizela: historie zpráv se obnovila, ale nabídka dalšího kroku
     ne, a zákazník zůstal v okně s holým textem. */
  function ukazTlacitka(seznam) {
    elTlacitka.textContent = '';
    var platna = Array.isArray(seznam)
      ? seznam.filter(function (t) { return typeof t === 'string' && t.trim(); }).slice(0, 5)
      : [];

    platna.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pk-chat__tlacitko';
      b.textContent = t.slice(0, 60);
      b.addEventListener('click', function () { posli(b.textContent); });
      elTlacitka.appendChild(b);
    });

    stav.tlacitka = platna;
    uloz();
  }

  function pise(zapni) {
    var byl = elZpravy.querySelector('.pk-chat__pise');
    if (byl) byl.remove();
    if (!zapni) return;
    var d = document.createElement('div');
    d.className = 'pk-chat__zprava pk-chat__zprava--bot pk-chat__pise';
    d.innerHTML = '<span></span><span></span><span></span>';
    d.setAttribute('aria-label', 'Asistent píše');
    elZpravy.appendChild(d);
    dolu();
  }

  function dolu() { elZpravy.scrollTop = elZpravy.scrollHeight; }

  /* ---------- otevření a zavření ---------- */

  function otevri() {
    elPanel.hidden = false;
    elBublina.hidden = true;
    schovejPozvanku();
    if (!stav.zpravy.length) {
      ukazZpravu('bot', N.uvitani);
      stav.zpravy.push({ role: 'bot', text: N.uvitani });
      uloz();
      ukazTlacitka(N.tlacitka);
    }
    /* Na mobilu se pole nefokusuje — vyjela by klávesnice přes celý panel
       dřív, než si zákazník stihne přečíst uvítání a tlačítka. */
    if (window.innerWidth > 600) elPole.focus();
    dolu();
  }

  function zavri() {
    elPanel.hidden = true;
    elBublina.hidden = false;
    elBublina.focus();
  }

  function schovejPozvanku() {
    if (elPozvanka) elPozvanka.hidden = true;
    stav.pozvano = true;
    uloz();
  }

  /* ---------- odeslání ---------- */

  function posli(text) {
    text = String(text || '').trim().slice(0, MAX_ZNAKU);
    if (!text || ceka) return;

    if (stav.odeslano >= LIMIT_ZPRAV) {
      ukazZpravu('chyba', N.limit);
      ukazTlacitka([]);
      return;
    }

    ukazZpravu('ja', text);
    stav.zpravy.push({ role: 'ja', text: text });
    stav.odeslano += 1;
    stav.posledni = Date.now();
    uloz();
    naplanuj();

    elPole.value = '';
    elPole.style.height = '';
    ukazTlacitka([]);
    zamkni(true);
    pise(true);

    /* Když n8n mlčí, nesmí widget viset donekonečna — po 30 s se to vzdá
       a nabídne e-mail. Radši přiznaná chyba než věčné tři tečky. */
    var vyprsi = new AbortController();
    var hlidac = setTimeout(function () { vyprsi.abort(); }, 30000);

    nactiKosik().then(function (kosik) {
      return fetch(N.webhook, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        signal: vyprsi.signal,
        body: JSON.stringify({
          token: N.token,
          session: stav.session,
          zprava: text,
          stranka: location.pathname,
          kosik: kosik
        })
      });
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (d) {
        var odp = d && typeof d.odpoved === 'string' && d.odpoved.trim() ? d.odpoved : N.chyba;
        ukazZpravu('bot', odp);
        stav.zpravy.push({ role: 'bot', text: odp });
        uloz();
        ukazTlacitka(d && d.tlacitka);
      })
      .catch(function () {
        ukazZpravu('chyba', N.chyba);
      })
      .then(function () {
        clearTimeout(hlidac);
        pise(false);
        zamkni(false);
        if (window.innerWidth > 600) elPole.focus();
      });
  }

  /* ---------- odpovědi člověka z obchodu ---------- */

  /* Na rozhovor z chatu může odpovědět člověk přes Telegram (workflow
     „PK CZ+SK · Chat — odpovědi z Telegramu"). Widget se proto po poslední
     zprávě zákazníka ještě 3 hodiny občas zeptá, jestli něco nepřišlo —
     15 s s otevřeným oknem, 45 s se zavřeným, nikdy ve skryté záložce.
     Když odpověď přijde, okno se samo otevře. */
  var ODPOVEDI = 'https://n8n.4lp.cz/webhook/pk-chat-odpovedi';
  var TRH = 'sk';
  var JAK_DLOUHO = 3 * 3600 * 1000;
  var casovac = null;

  function cekame() {
    return stav.posledni && Date.now() - stav.posledni < JAK_DLOUHO;
  }

  function naplanuj() {
    clearTimeout(casovac);
    if (!cekame()) return;
    casovac = setTimeout(vyzvedni, elPanel.hidden ? 45000 : 15000);
  }

  function vyzvedni() {
    clearTimeout(casovac);
    if (!cekame()) return;
    if (document.hidden) return naplanuj();
    fetch(ODPOVEDI + '?trh=' + TRH + '&session=' + encodeURIComponent(stav.session) +
      '&od=' + (stav.odpovedOd || 0), { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var nove = d && Array.isArray(d.zpravy) ? d.zpravy : [];
        var bylo = false;
        nove.forEach(function (z) {
          var cislo = Number(z && z.id);
          if (!cislo || cislo <= (stav.odpovedOd || 0) || typeof z.text !== 'string' || !z.text.trim()) return;
          stav.odpovedOd = cislo;
          stav.zpravy.push({ role: 'clovek', text: z.text });
          ukazZpravu('clovek', z.text);
          bylo = true;
        });
        if (bylo) {
          uloz();
          if (elPanel.hidden) otevri();
          dolu();
        }
      })
      .catch(function () { /* výpadek nevadí, zkusí se to znovu */ })
      .then(naplanuj);
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) vyzvedni();
  });

  function zamkni(ano) {
    ceka = ano;
    elPole.disabled = ano;
    elPoslat.disabled = ano;
  }

  /* ---------- obsluha ---------- */

  elBublina.addEventListener('click', otevri);
  elZavrit.addEventListener('click', zavri);
  elPoslat.addEventListener('click', function () { posli(elPole.value); });

  if (elPozvanka) {
    elPozvanka.addEventListener('click', otevri);
  }
  if (elPozvankaX) {
    elPozvankaX.addEventListener('click', function (e) {
      e.stopPropagation();
      schovejPozvanku();
    });
  }

  elPole.addEventListener('keydown', function (e) {
    /* Enter odesílá, Shift+Enter dělá nový řádek — jako všude jinde. */
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      posli(elPole.value);
    }
  });

  /* Pole roste s textem, ale jen do max-height z CSS. */
  elPole.addEventListener('input', function () {
    elPole.style.height = 'auto';
    elPole.style.height = Math.min(elPole.scrollHeight, 110) + 'px';
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !elPanel.hidden) zavri();
  });

  /* ---------- obnovení rozepsané konverzace ---------- */

  vyzvedni();

  if (stav.zpravy.length) {
    stav.zpravy.forEach(function (z) { ukazZpravu(z.role, z.text); });
    var byla = stav.tlacitka;
    otevri();
    ukazTlacitka(byla);
  } else if (elPozvanka && !stav.pozvano && N.pozvanka_po > 0) {
    setTimeout(function () {
      if (elPanel.hidden && !stav.pozvano) elPozvanka.hidden = false;
    }, N.pozvanka_po * 1000);
  }
})();
